export const cancellationReasons = [
  { reason: 'I will buy this product later ', checked: false },
  {
    reason: 'I was looking out for No-Cost EMI & better discounts',
    checked: false,
  },
  {
    reason: ' I want to know more about how cardless EMI works',
    checked: false,
  },
  { reason: 'None of these', checked: false },
];

export const otpPageCancellationReasons = [
  { reason: 'I will buy this product later', checked: false },
  {
    reason: 'I am not comfortable sharing my personal details',
    checked: false,
  },
  { reason: 'I am facing issues with OTP', checked: false },
  { reason: 'I will buy with other payment options', checked: false },
  { reason: 'None of these', checked: false },
];



// WEBPACK FOOTER //
// ./constants/transactionCancellationReasons.js